var _g, _g2, _path, _g3, _path2, _g4, _path3, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup582(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 190,
    viewBox: "0 0 174 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_276_139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83 20L111.275 36.0263L139.292 52.5L139.55 85L139.292 117.5L111.275 133.974L83 150L54.725 133.974L26.7083 117.5L26.45 85L26.7083 52.5L54.725 36.0263L83 20Z",
    fill: "#363ABF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_276_139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.6726 44.2296L83.5 30.7242L107.327 44.2296L130.937 58.1121L131.155 85.5L130.937 112.888L107.328 126.77L83.5 140.276L59.6725 126.77L36.0628 112.888L35.845 85.5L36.0628 58.1121L59.6726 44.2296Z",
    stroke: "white",
    strokeWidth: 3,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_276_139)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_276_139",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 58,
    width: 48,
    height: 82
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.0426 85.5838L83.8903 139.497L37.2847 112.419L37.4369 58.5068L84.0426 85.5838Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_276_139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.9757 85.6069L37.5026 58.606L37.4697 70.523L73.2639 91.3202L73.2354 101.581L56.1451 91.6519L56.1111 103.569L73.2014 113.497L73.1456 133.193L83.8234 139.397L83.9757 85.6069Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_276_139",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 31,
    width: 94,
    height: 55
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.454 58.3955L84.152 85.4736L37.5464 58.3966L83.8486 31.3186L130.454 58.3955Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_276_139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.8256 31.3825L73.2178 37.5863L90.2511 47.4827L73.2714 57.4112L83.5769 63.3989L100.555 53.4693L109.43 58.6259L73.8684 79.4219L84.1739 85.4096L130.345 58.4087L83.8256 31.3825Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_276_139",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 83,
    y: 58,
    width: 48,
    height: 82
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.383 58.5057L130.232 112.419L83.8906 139.519L84.0429 85.6069L130.383 58.5057Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_276_139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.298 58.6171L84.1283 85.6179L83.9761 139.408L94.5839 133.205L94.6397 113.509L111.619 103.579L111.652 91.663L94.6737 101.592L94.7022 91.3312L130.265 70.534L130.298 58.6171Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_276_139",
    x: 0.450195,
    y: 0,
    width: 173.1,
    height: 190,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.262745 0 0 0 0 0.380392 0 0 0 0 0.933333 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_276_139"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_276_139",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_276_139",
    x: 30.3452,
    y: 29,
    width: 106.31,
    height: 121,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_276_139"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_276_139",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_276_139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 109,
    fill: "white",
    transform: "translate(37 31)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup582);
export default __webpack_public_path__ + "static/media/Group 58-2.b3055819aacacbce8ca7801175c69148.svg";
export { ForwardRef as ReactComponent };